import './App.css';
import TodoList from './components/TodoList';


function App() {
  return (
    <div className="App">
      <center>
      <TodoList />
      </center>
    </div>
  );
}

export default App;
